import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Contemporary_Period_-_Climate_Change_and_Environmental_Movements.png';

function HistoryPageClimateChange() {
  return (
    <TopicPage
      topicKey="Climate Change and Environmental Movements"
      title="History: Climate Change and Environmental Movements"
      backgroundImage={bg}
      startRoute="/History-Climate-Change-Go"
      scrollLabels={[
        "Industrial Impact on Environment",
        "Environmental Movements",
        "International Climate Agreements"
      ]}
      backRoute="/history-contemporary"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageClimateChange;
